import React, { useEffect, useState } from 'react';
import {
  TUIKit,
  TUIConversationList,
  TUIChat,
  TUIChatHeader,
  TUIMessageList,
  TUIMessageInput,
  TUIProfile,
  TUIConversation,
  TUIManage,
  i18next,
} from '@tencentcloud/chat-uikit-react';
import TencentCloudChat from '@tencentcloud/chat';
import { TUIStore, StoreName } from "@tencentcloud/chat-uikit-engine";
import { TUILogin } from "@tencentcloud/tui-core";
import './style.scss'
import { loginOverseas } from '../demo/api';
import { genTestUserSig } from '../debug/GenerateTestUserSig'
import '@tencentcloud/chat-uikit-react/dist/cjs/index.css';
import './style.scss';

import { sampleResources } from '../locales/index';

// 追加 sample 语言包
if (i18next.language === 'zh') {
  i18next.addResources(i18next.language, 'translation', sampleResources?.zh);
} else {
  i18next.addResources(i18next.language, 'translation', sampleResources?.en);
}

export default function SocialDemo(props: any) {
  const {
    className,
    userID: propsUserID,
  } = props;

  // TUIMessageInput config
  const TUIMessageInputConfig = {
    className: 'sample-h5-input',
    isTransmitter: true
  }

  const botConversationList = ['TUILiveKitDemo001', 'AK3PWmVXZu3ByVOE', 'KZJb8oATrgUnETai'];
  const [chat, setChat] = useState<any>();
  const [currentConversationID, setCurrentConversationID] = useState<string>('');;
  const [currentLanguage] = useState<string>('en');

  const init = (SDKAppID:number, userID:string, userSig:string) => {
    const loginInfo: any = {
      SDKAppID,
      userID,
      userSig,
      useUploadPlugin: true,
      useProfanityFilterPlugin: true,
    };
    TUILogin.login(loginInfo).then((res: any) => {
      const { chat } = TUILogin.getContext();
      setChat(chat);
    });
  }

  useEffect(() => {
    (async () => {
      const res = await loginOverseas();
      if (propsUserID) {
        init(genTestUserSig(propsUserID).SDKAppID, propsUserID, genTestUserSig(propsUserID).userSig);
        return;
      }
      const {userID, userSig} = res.data;
      init(genTestUserSig(userID).SDKAppID, userID, userSig);
    })()
  }, [propsUserID]);

  useEffect(() => {
    TUIStore.watch(StoreName.CONV, {
      currentConversationID: (id: string) => {
        setCurrentConversationID(id);
      }
    });
  }, []);

  const handleCreateConversation = async (params: string | any) => {
    // create c2c conversation
    if (typeof params === "string") {
      const { data } = await chat?.getConversationProfile(params);
      return data.conversation;
    }

    // create group conversation
    const {
      name,
      type,
      groupID,
      introduction,
      notification,
      avatar,
      maxMemberNum,
      joinOption,
      memberList = [],
      groupCustomField = [],
    } = params;
    const res = await chat?.createGroup({
      name,
      type,
      groupID,
      introduction,
      notification,
      avatar,
      maxMemberNum,
      joinOption,
      memberList,
      groupCustomField,
    });
    const { groupID: createdGroupID } = res.data.group;
    if (type === TencentCloudChat.TYPES.GRP_AVCHATROOM) {
      await chat?.joinGroup({
        groupID: createdGroupID,
        type: TencentCloudChat.TYPES.GRP_AVCHATROOM,
      });
    }
    const { data } = await chat?.getConversationProfile(
      `GROUP${createdGroupID}`
    );
    return data.conversation;
  };

  const filterConversation = (conversationList: Array<any>) => {
    return conversationList.filter((item)=>{
      return item.type !== TencentCloudChat.TYPES.CONV_SYSTEM && !botConversationList.includes(item.conversationID);
    })
  };

  return (
    <div className={`sample-chat-h5 ${className}`}>
      <TUIKit chat={chat} language={currentLanguage}>
        {/* 左侧 list 显示 */}
        {!currentConversationID && (
          <div className="sample-chat-h5-container">
            <TUIProfile className="sample-profile" />
            <TUIConversation createConversation={handleCreateConversation}>
              <TUIConversationList filterConversation={filterConversation} />
            </TUIConversation>
          </div>
        )}

        {/* 右侧对应内容显示 */}

        {currentConversationID && (
          <>
            <TUIChat TUIMessageInputConfig={TUIMessageInputConfig}>
              <TUIChatHeader />
              <TUIMessageList />
              <TUIMessageInput />
            </TUIChat>
            <TUIManage></TUIManage>
          </>
        )}
      </TUIKit>
    </div>
  );
}
